import { AssertIsNotNilException } from './assert-is-not-nil.exception';
import { isNil } from '@camino-solutions/utils/typeguard';

export function assertIsNotNil<T>(value: T): asserts value is NonNullable<T> {
  if (isNil(value)) {
    throw new AssertIsNotNilException(`Is a nil: ${value}`);
  }
}
